import {
  DadosTitularPix,
  DependentePix,
} from "../types/PixAutomaticoTypes";

function formatarDataIso(data: string): string {
  return data.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$2-$1");
}

function limparNumeros(valor: string): string {
  return valor.replace(/[^0-9]/g, "");
}

function montarEndereco(endereco: DependentePix["address"]) {
  return {
    zip_code: limparNumeros(endereco?.zip_code || ""),
    state: endereco?.state || "",
    city: endereco?.city || "",
    street: endereco?.street || "",
    number: endereco?.number || "",
    neighborhood: endereco?.neighborhood || "",
    complement: endereco?.complement || "",
  };
}

export function montarCorpoPixAutomatico(
  dadosTitular: DadosTitularPix,
  dependentes: DependentePix[],
  codigoPlano: string,
  codigoGerente: string | null
) {
  const dependentesFormatados = dependentes.map((dependente) => ({
    name: dependente.name || "",
    phone: limparNumeros(dependente.phone || ""),
    email: dependente.email || "",
    cpf: limparNumeros(dependente.cpf || ""),
    birthday: dependente.birthday
      ? formatarDataIso(dependente.birthday)
      : "",
    address: montarEndereco(dependente.address),
  }));

  return {
    principal: {
      name: dadosTitular.name,
      phone: limparNumeros(dadosTitular.phone),
      email: dadosTitular.email,
      cpf: limparNumeros(dadosTitular.cpf),
      birthday: formatarDataIso(dadosTitular.birthday),
      address: montarEndereco(dadosTitular.address),
      payment: {
        plan_code: codigoPlano,
        codigo_gerente: codigoGerente,
      },
    },
    dependentes: dependentesFormatados,
  };
}
